export default __webpack_public_path__ + "static/861-dcf22a669edc50072b67f546eb53aaaa.gif";